<app-contact></app-contact>

<app-supported-browsers></app-supported-browsers>
